export const fetchData = (url, options) => {
  return axios.get(url, options)
}

export const sendData = (url, data, options) => {
  return axios.post(url, data, options)
}

export const putData = (url, data, options) => {
  return axios.put(url, data, options)
}

export const deleteData = (url, data) => {
  return axios.delete(url, data)
}

export const patchData = (url, data, options) => {
  return axios.patch(url, data, options)
}
